// Shared conviction status vocabulary + badge styling so the admin CMS and the
// public thesis pages stay visually consistent.
export const CONVICTION_STATUSES = ["HIGH CONVICTION", "MEDIUM", "HIGH RISK", "INVALIDATED"];

export function convictionBadgeClass(status) {
  switch (status) {
    case "INVALIDATED":
      return "border-red-500/40 text-red-400";
    case "HIGH RISK":
      return "border-amber-500/40 text-amber-400";
    case "MEDIUM":
      return "border-white/25 text-zinc-300";
    default: // HIGH CONVICTION
      return "border-[#ccff00]/40 text-[#ccff00]";
  }
}
